export default "__VITE_ASSET__B3ULweQ___"